// extracted by mini-css-extract-plugin
var _1 = "EntityTabProviders-moduleEntityTabProviders___iyTk";
var _2 = "EntityTabProviders-moduleactions__iqedP";
var _3 = "EntityTabProviders-moduleemptyPage__K7wlw";
var _4 = "EntityTabProviders-modulepagination__awBkM TablePagination-moduleTablePagination__cupJ7";
var _5 = "EntityTabProviders-moduletoolbar__XnPgC";
export { _1 as "EntityTabProviders", _2 as "actions", _3 as "emptyPage", _4 as "pagination", _5 as "toolbar" }
